import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
import { ProtectedRoleTecnical } from "../hooks/roles/ProtectedRoleTecnical";

const ErrorPage = React.lazy(() => import("../components/error-page"));

const TareaDetalleMasInfoTecnico = React.lazy(
  () =>
    import("../components/task/tecnical/tareaDetalleMasInfoTecnico/tarea-detalle-mas-info-tecnico"),
);

export function tareaDetalleMasInfoTecnico() {
  return (
    <Route
      path="/tarea-detalle-mas-info-tecnico"
      element={
        <LazySuspense>
          <ProtectedRoute>
            <ProtectedRoleTecnical>
              <LazySuspense>
                <TareaDetalleMasInfoTecnico />
              </LazySuspense>
            </ProtectedRoleTecnical>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
